import { render } from "./CIS-DropDown-TwoColumn.vue?vue&type=template&id=7c2506f0&scoped=true"
import script from "./CIS-DropDown-TwoColumn.vue?vue&type=script&lang=js"
export * from "./CIS-DropDown-TwoColumn.vue?vue&type=script&lang=js"

import "./CIS-DropDown-TwoColumn.vue?vue&type=style&index=0&id=7c2506f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2506f0"]])

export default __exports__